import { render } from "./app-sidebar-item-pack.vue?vue&type=template&id=a59287fe"
import script from "./app-sidebar-item-pack.vue?vue&type=script&lang=js"
export * from "./app-sidebar-item-pack.vue?vue&type=script&lang=js"
script.render = render

export default script